import { Button, Col, Form, Input, Row, Typography } from 'antd'
import React from 'react'
import CIMSFormItem from 'components/CIMSFormItem'
import { DeleteTwoTone } from '@ant-design/icons'
import { HelpMessage } from 'utils/constants'

/**
 * set `customListItems` in the initialValues of the associated {@link Form}
 */
const CustomListItemFormItems: React.FC = () => {
  return (
    <>
      <Typography.Paragraph>
        {HelpMessage.Administration.CustomFields.Items}.
      </Typography.Paragraph>
      <Form.List name="customListItems">
        {(fields, { add, remove }) => (
          <>
            <Row style={{ marginBottom: '1rem' }}>
              <Button type="primary" onClick={() => add()}>
                Add Item
              </Button>
            </Row>
            {fields.map(({ name, key }) => (
              <Row key={key} gutter={8}>
                <Col flex={5}>
                  <CIMSFormItem
                    name={[name, 'value']}
                    label="Value"
                    requiredMessage="Please enter a custom list item value"
                  >
                    <Input allowClear />
                  </CIMSFormItem>
                </Col>
                <Col span={1}>
                  <DeleteTwoTone
                    style={{ fontSize: '1.5em', marginTop: '0.25em' }}
                    onClick={() => remove(name)}
                  />
                </Col>
              </Row>
            ))}
          </>
        )}
      </Form.List>
    </>
  )
}

export default CustomListItemFormItems
